if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function () { // eslint-disable-line
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}
